import axios from "axios";
const baseUrlCrm = process.env.REACT_APP_CRM_URL + 'Crm/';
const apiKey = process.env.REACT_APP_CRM_TOKEN;


export const NegocioComContato = async (leadContato) => {
    try {
        const response = await axios.post(baseUrlCrm + "NegocioComContato",
            leadContato,
            {
                headers: {
                    "Content-Type": "application/json",
                    "ApiKey": apiKey,
                },
            }
        );
        return Promise.resolve(response.data);
    } catch (error) {
        return Promise.reject(error);
    }
}

export const PatchContato = async (contato) => {
    try {
        const response = await axios.patch(baseUrlCrm + "Contato",
            contato,
            {
                headers: {
                    "Content-Type": "application/json",
                    "ApiKey": apiKey,
                },
            }
        );
        return Promise.resolve(response.data);
    } catch (error) {
        return Promise.reject(error);
    }
}

export const PatchNegocio = async (negocio, email) => {
    try {
        const response = await axios.patch(
            baseUrlCrm + "Negocio?emailContato=" + encodeURIComponent(email),
            negocio,
            {
                headers: {
                    "Content-Type": "application/json",
                    "ApiKey": apiKey,
                },
            }
        );
        return Promise.resolve(response.data);
    } catch (error) {
        return Promise.reject(error);
    }
}

export const PostEmpresa = async (contatoEmail, empresa) => {
    try {
        const response = await axios.post(baseUrlCrm + "Empresa", empresa, {
            params: {
                contatoEmail: contatoEmail,
            },
            headers: {
                "Content-Type": "application/json",
                "ApiKey": apiKey,
            },
        })
        return Promise.resolve(response.data);
    }
    catch (error) {
        return Promise.reject(error);
    }
}